import { api } from "../services/api";

// Cabeçalho vem de /configuracoes/dados-empresa/cabecalho/ (dado real da
// empresa/fazenda logada, nunca hardcoded). Busca de novo em toda exportação
// — sem cache: já teve versão com cache em memória, e ela servia dado velho
// depois de editar telefone/logo em Configurações sem recarregar a página
// (o cache só zerava com F5). É um GET pequeno, não vale a pena arriscar.
//
// Extraído de relatorioPdf.js pra ser reaproveitado por qualquer PDF do
// sistema, tabular ou não (ver relatorioSoloPdf.js) — o cabeçalho/rodapé
// padrão não deve ser reimplementado em cada utilitário novo.
export async function buscarCabecalhoEmpresa() {
  try {
    const res = await api.get("/configuracoes/dados-empresa/cabecalho/");
    return res.data || {};
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("Não foi possível carregar os dados da empresa pro cabeçalho do relatório:", err);
    return {};
  }
}

function formatoImagem(dataUri) {
  const m = /^data:image\/(png|jpe?g)/i.exec(dataUri || "");
  if (!m) return null;
  return m[1].toLowerCase().startsWith("jpe") ? "JPEG" : "PNG";
}

/**
 * Desenha o cabeçalho padrão (logo, nome da empresa, cidade/UF, telefone,
 * título do relatório, período, data/hora de geração) num `doc` jsPDF já
 * criado. Devolve a altura reservada — quem chama usa isso pra saber onde
 * o conteúdo pode começar (mesma lógica em toda página, via `margin.top`
 * do jspdf-autotable ou controle manual de `startY`).
 */
export function desenharCabecalhoPadrao(doc, { titulo, periodo, empresa, largura, margem = 10 }) {
  const alturaCabecalho = periodo ? 40 : 34;
  const centroX = largura / 2 + 8; // levemente à direita do centro, abrindo espaço pro bloco de data à direita
  const agora = new Date();

  doc.setDrawColor(190);
  doc.roundedRect(margem, 10, largura - margem * 2, alturaCabecalho, 2, 2);

  const formato = formatoImagem(empresa.empresa_logo);
  if (formato) {
    try {
      doc.addImage(empresa.empresa_logo, formato, margem + 3, 13, 26, alturaCabecalho - 6, undefined, "FAST");
    } catch {
      // Logo corrompido ou formato que o jsPDF recusou: segue sem imagem,
      // nunca quebra a exportação por causa de um logo ruim.
    }
  }

  const blocoDataX = largura - margem - 3;
  doc.line(blocoDataX - 40, 10, blocoDataX - 40, 10 + alturaCabecalho);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(empresa.empresa_nome || empresa.fazenda_nome || "", centroX, 18, { align: "center" });

  const cidadeUf = [empresa.fazenda_cidade, empresa.fazenda_estado].filter(Boolean).join("/");
  const contato = [cidadeUf, empresa.empresa_telefone && `Fone: ${empresa.empresa_telefone}`]
    .filter(Boolean)
    .join("   ·   ");
  if (contato) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(contato, centroX, 24, { align: "center" });
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(titulo, centroX, periodo ? 32 : 29, { align: "center" });

  if (periodo) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(`Período: ${periodo}`, centroX, 38, { align: "center" });
  }

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(110);
  doc.text("Gerado em", blocoDataX, 16, { align: "right" });
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor(40);
  doc.text(agora.toLocaleDateString("pt-BR"), blocoDataX, 23, { align: "right" });
  doc.text(agora.toLocaleTimeString("pt-BR"), blocoDataX, 30, { align: "right" });

  return alturaCabecalho;
}

/** Numera "Página X de Y" no rodapé de toda página já desenhada no `doc`. */
export function desenharRodapePaginacao(doc, { largura, altura, margem = 10 }) {
  const totalPaginas = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPaginas; i++) {
    doc.setPage(i);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(130);
    doc.text(`Página ${i} de ${totalPaginas}`, largura - margem, altura - 8, { align: "right" });
  }
}
